export const COMPANY = {
    name: "Virtex Renewables Ltd",
    shortName: "Virtex Renewables",
    companyNumber: "17467990",
    phoneDisplay: "0333 014 0227",
    phoneHref: "tel:03330140227",
    email: "info@virtexrenewables.co.uk",
    emailHref: "mailto:info@virtexrenewables.co.uk",
    website: "virtexrenewables.co.uk",
    coverage: "England & Wales",
    tagline: "Clean Energy for a Brighter Tomorrow",
    registeredOffice: [
        "Virtex Renewables Ltd",
        "Flat 2 Park Lane Court",
        "31 Parsonage Road",
        "Manchester",
        "England",
        "M20 4PS",
    ],
};

export const LOGO = "/assets/virtex-logo.png";
export const LOGO_WHITE = "/assets/virtex-logo-white.png";

export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1776860150305-108ed577d7d4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwzfHxoZWF0aW5nJTIwZW5naW5lZXIlMjBIVkFDJTIwaW5zdGFsbGF0aW9uJTIwaGVhdCUyMHB1bXAlMjBob21lfGVufDB8fHx8MTc5MTgzOTkzNXww&ixlib=rb-4.1.0&q=85",
    heatPumpUnit:
        "https://images.unsplash.com/photo-1718203862467-c33159fdc504?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHxoZWF0aW5nJTIwZW5naW5lZXIlMjBIVkFDJTIwaW5zdGFsbGF0aW9uJTIwaGVhdCUyMHB1bXAlMjBob21lfGVufDB8fHx8MTc5MTgzOTkzNXww&ixlib=rb-4.1.0&q=85",
    townhouse:
        "https://images.unsplash.com/photo-1598307754921-da47ead0ad5f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBCcml0aXNoJTIwaG9tZSUyMGdhcmRlbiUyMGV4dGVyaW9yJTIwYnJpY2t8ZW58MHx8fHwxNzkxODM5OTI5fDA&ixlib=rb-4.1.0&q=85",
    suburban:
        "https://images.unsplash.com/photo-1607900840367-a83dcd63296d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBCcml0aXNoJTIwaG9tZSUyMGdhcmRlbiUyMGV4dGVyaW9yJTIwYnJpY2t8ZW58MHx8fHwxNzkxODM5OTI5fDA&ixlib=rb-4.1.0&q=85",
    country:
        "https://images.unsplash.com/photo-1590992414274-74fd8f58cff2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHw0fHxVSyUyMGJyaWNrJTIwaG91c2UlMjBoZWF0JTIwcHVtcCUyMGluc3RhbGxhdGlvbiUyMGV4dGVyaW9yfGVufDB8fHx8MTc5MTgzOTkyOXww&ixlib=rb-4.1.0&q=85",
};

export const NAV_LINKS = [
    { label: "Home", to: "/" },
    { label: "Heat Pumps", to: "/heat-pumps" },
    { label: "Boiler Upgrade Scheme", to: "/boiler-upgrade-scheme" },
    { label: "About Us", to: "/about-us" },
    { label: "FAQs", to: "/faqs" },
    { label: "Contact", to: "/contact" },
];

export const LEGAL_LINKS = [
    { label: "Privacy Policy", to: "/privacy-policy" },
    { label: "Cookie Policy", to: "/cookie-policy" },
    { label: "Terms & Conditions", to: "/terms-and-conditions" },
    { label: "Complaints", to: "/complaints" },
];

export const FAQS = [
    {
        q: "How does an air source heat pump work?",
        a: "An air source heat pump extracts heat energy from the outside air and upgrades it to a higher temperature using a refrigeration cycle. That heat is then transferred into your home's heating and hot-water system. Because the system moves heat rather than generating it through combustion, it can deliver more heat energy than the electricity it consumes.",
    },
    {
        q: "Can a heat pump replace my gas boiler?",
        a: "In many homes, yes. Whether a heat pump is the right replacement depends on the property's heat loss, insulation, radiators, hot-water demand and available space for the outdoor unit and cylinder. A property assessment and heat-loss calculation are carried out before any recommendation is made.",
    },
    {
        q: "Can a heat pump replace an oil boiler?",
        a: "Yes. Homes currently heated by oil or LPG are often strong candidates for air source heat pumps, particularly rural and off-gas properties. Suitability still depends on the individual property, which is why the assessment and system design stage matters.",
    },
    {
        q: "Will I need to replace my radiators?",
        a: "Not always. Heat pumps run at lower flow temperatures than traditional boilers, so some radiators may need to be upsized to deliver the same heat output. This is determined during the heat-loss and system design stage, and any required changes are explained before work begins.",
    },
    {
        q: "Does a heat pump provide hot water?",
        a: "Yes. A correctly designed air source heat pump system provides both space heating and domestic hot water, usually via a hot-water cylinder specified for use with a heat pump.",
    },
    {
        q: "Can a heat pump work in winter?",
        a: "Yes. Modern air source heat pumps are designed to operate throughout the UK heating season, including cold winter conditions. Output and efficiency vary with outdoor temperature, which is why correct sizing and system design for the specific property are essential.",
    },
    {
        q: "What is the Boiler Upgrade Scheme?",
        a: "The Boiler Upgrade Scheme is a UK Government grant scheme supporting property owners in England and Wales who replace eligible fossil-fuel heating systems with low-carbon heating, such as an air source heat pump.",
    },
    {
        q: "How much is the Boiler Upgrade Scheme grant?",
        a: "The scheme provides a grant of up to £7,500 towards an eligible air source heat pump installation. Funding is subject to eligibility, property suitability and the scheme rules in force at the time, and cannot be guaranteed.",
    },
    {
        q: "Can landlords install heat pumps?",
        a: "Yes. Landlords can consider air source heat pumps for rental properties. Scheme eligibility depends on the property and the current scheme rules, and the same assessment-led design process applies.",
    },
    {
        q: "Is every property suitable for a heat pump?",
        a: "No. Suitability depends on factors including heat loss, insulation, radiator capacity, hot-water requirements, outdoor space and the existing heating system. That is why every project begins with a property assessment rather than a one-size-fits-all quote.",
    },
];
